module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.searchable) ? _c('div', {
    staticClass: "block-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form__text_lg txt-search",
    attrs: {
      "type": "text",
      "placeholder": "ค้นหา"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.loaded && _vm.items.length > 0) ? _c('ul', {
    staticClass: "result-item"
  }, _vm._l((_vm.items), function(item, i) {
    return _c('li', {
      staticClass: "result-list",
      class: {
        official: _vm.isOfficial(item)
      }
    }, [_c('div', {
      staticClass: "hexagon"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(i + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "result-detail"
    }, [(_vm.link) ? _c('span', {
      staticClass: "title"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.getLink(item)
      }
    }, [_vm._v(_vm._s(_vm.getTitle(item)))])], 1) : _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.getTitle(item)))]), _vm._v(" "), _c('span', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm._f("comma")(_vm.getTotal(item))))])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.loaded && _vm.error && !_vm.loading) ? _c('div', {
    staticClass: "w-50 ma-auto mt-15 mb-15"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("ไม่พบข้อมูล")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn--white",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.refresh.apply(null, arguments)
      }
    }
  }, [_vm._v("โหลดใหม่อีกครั้ง")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-50 ma-auto mt-15 mb-15"
  }, [(_vm.showLoadMore && _vm.items.length > 0) ? _c('a', {
    staticClass: "btn btn--white",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadMore.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.loadMoreButtonText))]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ec427cf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductLeaderboard.vue
// module id = 1166
// module chunks = 0